

export const HOST_OMDB = '';

export const PORT_OMDB = '';

export const ROOT_OMDB = `${HOST_OMDB}${(PORT_OMDB!=='')?`:${PORT_OMDB}`:''}?apikey=${process.env.REACT_APP_OMDB_KEY}`;

